export const cloneControl = {
  defaultButton: `Clonar`,
  defaultNoun: `configuración`,
  itemNounDefault: `esta configuración`,
  pullTitle: `Traer configuración de otro alojamiento`,
  pushTitle: `Copiar esta configuración a otro alojamiento`,
  pullSubReplace: `Se aplicará a este alojamiento`,
  pullSubAdd: `Se sumará a la de este alojamiento`,
  pushSubReplace: `Se aplicará a los que elijas`,
  pushSubAdd: `Se sumará a la de los que elijas`,
  pullTitleFull: `Traer {noun}`,
  pushTitleFull: `Copiar {noun}`,
  pullSubtitle: `Elige el alojamiento del que traer la configuración. Se aplicará a este.`,
  pushSubtitle: `Copia esta configuración a los alojamientos que elijas.`,
};
